/**
 * Computes business presence checklist and score from merchant general settings.
 * Used by Visibility Checker page to show what's filled and what to improve.
 */

const ITEMS = [
    {
        id: 'name',
        label: 'Business name',
        description: 'Your store name is visible on passes and to customers.',
        settingsKey: 'name',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'website',
        label: 'Website',
        description: 'A website helps customers find you and builds trust.',
        settingsKey: 'website',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'phone',
        label: 'Phone number',
        description: 'Customers can call you for orders or questions.',
        settingsKey: 'phone',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'address',
        label: 'Address',
        description: 'Your address helps with local search and passes.',
        settingsKey: 'address',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'review_link',
        label: 'Google Maps link',
        description: 'Your Google Maps link helps customers find your location and leave reviews.',
        settingsKey: 'review_link',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'logo',
        label: 'Logo',
        description: 'A logo makes your brand recognizable on passes and marketing.',
        settingsKey: 'logo_url',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'category',
        label: 'Business category',
        description: 'Category helps customers find you in search.',
        settingsKey: 'category',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'facebook_url',
        label: 'Facebook',
        description: 'Link to your Facebook page for better visibility.',
        settingsKey: 'facebook_url',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'instagram_url',
        label: 'Instagram',
        description: 'Link to your Instagram profile.',
        settingsKey: 'instagram_url',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'twitter_url',
        label: 'X (Twitter)',
        description: 'Link to your X / Twitter profile.',
        settingsKey: 'twitter_url',
        linkPath: '/dashboard/settings/general',
    },
    {
        id: 'linkedin_url',
        label: 'LinkedIn',
        description: 'Link to your LinkedIn company page.',
        settingsKey: 'linkedin_url',
        linkPath: '/dashboard/settings/general',
    },
];

/**
 * @param {Record<string, string>} settings - Merchant general settings (name, website, etc.)
 * @returns {{ score: number, total: number, items: Array<{ id: string, label: string, description: string, complete: boolean, value?: string, linkPath: string }> }}
 */
export function getPresenceChecklist(settings = {}) {
    const items = ITEMS.map((item) => {
        const value = settings[item.settingsKey];
        const complete = Boolean(value && String(value).trim());
        return {
            ...item,
            complete,
            value: value ? String(value).trim() : undefined,
        };
    });

    const completed = items.filter((i) => i.complete).length;
    const total = items.length;
    const score = total ? Math.round((completed / total) * 100) : 0;

    return { score, total, items };
}

/**
 * Label for score range (for display).
 * @param {number} score
 * @returns {'Great'|'Good'|'Needs work'|'Getting started'}
 */
export function getScoreLabel(score) {
    if (score >= 85) {
        return 'Great';
    }
    if (score >= 60) {
        return 'Good';
    }
    if (score >= 30) {
        return 'Needs work';
    }
    return 'Getting started';
}
